/**
 * @file QuoteWithAuthorNode.ts
 * @description Кастомная Tiptap-нода — цитата с подписью автора (phase12.0).
 *
 * HTML-выход:
 *   <figure data-type="quote-with-author">
 *     <blockquote>…</blockquote>
 *     <figcaption>автор</figcaption>
 *   </figure>
 *
 * `apps/web` рендерит `<figcaption>` стилем под фирменный Marianna-italic.
 */

import { Node, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    quoteWithAuthor: {
      insertQuoteWithAuthor: () => ReturnType;
    };
  }
}

export const QuoteWithAuthorNode = Node.create({
  name: "quoteWithAuthor",
  group: "block",
  content: "block+",
  defining: true,

  addAttributes() {
    return {
      author: {
        default: "",
        parseHTML: (el) =>
          el.querySelector("figcaption")?.textContent?.trim() ?? "",
      },
    };
  },

  parseHTML() {
    return [{ tag: 'figure[data-type="quote-with-author"]' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const author = (node.attrs as { author?: string }).author ?? "";
    return [
      "figure",
      mergeAttributes({ "data-type": "quote-with-author" }, HTMLAttributes),
      ["blockquote", {}, 0],
      ["figcaption", {}, author],
    ];
  },

  addCommands() {
    return {
      insertQuoteWithAuthor:
        () =>
        ({ chain }) =>
          chain()
            .focus()
            .insertContent({
              type: this.name,
              attrs: { author: "" },
              content: [{ type: "paragraph" }],
            })
            .run(),
    };
  },
});
